import { useMutation } from '@tanstack/react-query';
import {
  ReferralProgramService,
  UpdateReferralProgramDto,
  GetReferralProgramEntity,
} from 'services/openapi';

export const useUpdateReferralDetailMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<GetReferralProgramEntity, Error, UpdateReferralProgramDto>({
      mutationFn: (variables: UpdateReferralProgramDto) => {
        return ReferralProgramService.referralProgramControllerPatchReferralProgram(
          variables,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
